import type { ContentfulHeadingFragment } from '@/graphql/contentful/api';

import { renderContentfulHeadingSection } from './cms';

export interface HeadingProps {
  Heading?: ContentfulHeadingFragment;
  color?: string;
  colorized?: boolean;
  htmlElementTag?: keyof HTMLElementTagNameMap;
  isHeroSlider?: boolean;
  // eslint-disable-next-line
  mobileTextAlign?: string;
  numberOfColoredWords?: number;
  shouldApplyBottomPadding?: boolean;
  sizeDesktop?: number;
  sizeMobile?: number;
}

export const Heading = (props: HeadingProps) => {
  return <> {renderContentfulHeadingSection(props)}</>;
};
